import React, { Component } from "react";
import TimeInput from "./TimeInput";
import {throttle} from "lodash";

import UpIcon from "./img/Up.svg"
import DownIcon from "./img/Down.svg"
import DotIcon from "./img/Dot.svg"

import "./style.scss";

import {
  start,
  drag,
  end,
  setDragImage,
  //getTarget,
  getTransform
} from "./DragFunctions"

export class CyclingStep extends Component {

  constructor(props) {
    super(props);

    this.state = {
      objCurrent: null,
      maxHeight: 0,
      offset1: null,
      offset2: null,
      offset3: null,
      temp1: this.props.props.subSteps[0].temp,
      temp2: this.props.props.subSteps[1].temp,
      temp3: this.props.props.subSteps[2].temp,
      duration1: this.props.props.subSteps[0].duration,
      duration2: this.props.props.subSteps[1].duration,
      duration3: this.props.props.subSteps[2].duration,
      repeat: this.props.props.repeat,
    };

    this.dragarea = React.createRef();
    this.dragToggle1 = React.createRef();
    this.dragToggle2 = React.createRef();
    this.dragToggle3 = React.createRef();
  }

  setCycleCount = (e, index) => {
    // let current = this.props.sequence[index];
    // current.repeat = e.target.value;
    //
    // this.props.updateSequence(index, current)
    if(e.target.value !== ""){
      this.setState({
        repeat: parseInt(e.target.value, 10)
      }, ()=>this.props.updateSequenceRepeat({}))
    } else {
      this.setState({
        repeat: e.target.value
      }, ()=>this.props.updateSequenceRepeat({}))
    }
  }

  setSubStepDuration = (duration, index, innerIndex) => {
    // let current = this.props.sequence[index];
    // current.subSteps[innerIndex].duration = e.target.value;
    //
    // this.props.updateSequence(index, current)
    this.setState({
      ["duration" + (innerIndex + 1)]: duration
    }, ()=>this.props.updateSequenceTime({}))
  }

  setOffset = (innerIndex) => {

    if(this.state.objCurrent){
      let offset = this.state.maxHeight - getTransform(this.state.objCurrent).translateY

      this.setState({
        ["offset" + (innerIndex + 1)]: offset,
        ["temp" + (innerIndex + 1)]: this.convertOffsetToTemp(offset)
      })
    }
  }

  onDragStart = (e) => {
    this.setState({
      objCurrent: e.target
    })

    setDragImage(e)
    start(e, e.target, this.state.sceneScale, this.state.userScale)
  }

  onDragOver = throttle((e, index, innerIndex) => {
     e.preventDefault();
     drag(e, this.state.objCurrent, this.state.maxHeight);
     this.setOffset(innerIndex)
   }, 10);

  onDrop = (e, index, innerIndex) => {
    e.preventDefault()
    end(e, this.state.objCurrent)

    this.setState({
      objCurrent: null
    })
    this.setOffset(innerIndex)
    this.props.updateSequenceTemp({})
  }

  convertOffsetToTemp = (offset) => {

    let percentage = offset / this.state.maxHeight
    return Math.round(95 * percentage);
  }

  convertTempToOffset = (temp) => {

    let percentage = temp / 95;
    return (this.state.maxHeight * (percentage));
  }

  setMaxHeight = () => {
    let height = (this.dragarea.current.getBoundingClientRect().height - 52)

    this.setState({
      maxHeight: height
    })

    this.setState({
      maxHeight: height
    }, ()=>{
      this.setState({
        offset1: this.convertTempToOffset(this.props.props.subSteps[0].temp),
        offset2: this.convertTempToOffset(this.props.props.subSteps[1].temp),
        offset3: this.convertTempToOffset(this.props.props.subSteps[2].temp)
      })
    })
  }

  save = () => {

    let step = this.props.sequence[this.props.props.id - 1];

    step.subSteps.forEach((subStep, index)=>{

      let temp = this.convertOffsetToTemp(this.state["offset"+(index+1)]);
      let duration = this.state["duration"+(index+1)];
      step.subSteps[index].temp = temp;
      step.subSteps[index].duration = duration;

    })

    step.repeat = this.state.repeat;
    this.props.updateSequence({
      id: this.props.id,
      index: this.props.props.id - 1,
      item: step
    });
  }

  moveUp = (stepId) => {
    let temp = this.state["temp" + stepId] + 1;

    if(temp >= 0 && temp <= 95){
      this.setState({
        ["temp" + stepId]: temp,
        ["offset" + stepId]: this.convertTempToOffset(temp)
      }, () => {
        let step = this.props.sequence[this.props.props.id - 1];

        step.subSteps.forEach((subStep, index)=>{

          let temp = this.convertOffsetToTemp(this.state["offset"+(index+1)]);
          let duration = this.state["duration"+(index+1)];
          step.subSteps[index].temp = temp;
          step.subSteps[index].duration = duration;

        })

        step.repeat = this.state.repeat;
        this.props.updateSequence({
          id: this.props.id,
          index: this.props.props.id - 1,
          item: step
        });
      })
    }
  }

  moveDown = (stepId) => {
    let temp = this.state["temp" + stepId] - 1;

    if(temp >= 0 && temp <= 95){
      this.setState({
        ["temp" + stepId]: temp,
        ["offset" + stepId]: this.convertTempToOffset(temp)
      }, () => {
        let step = this.props.sequence[this.props.props.id - 1];

        step.subSteps.forEach((subStep, index)=>{

          let temp = this.convertOffsetToTemp(this.state["offset"+(index+1)]);
          let duration = this.state["duration"+(index+1)];
          step.subSteps[index].temp = temp;
          step.subSteps[index].duration = duration;

        })

        step.repeat = this.state.repeat;
        this.props.updateSequence({
          id: this.props.id,
          index: this.props.props.id - 1,
          item: step
        });
      })
    }
  }

  onChange = (e, stepId) => {
    if(e.target.value >= 0 && e.target.value <= 95){
      this.setState({
        ["temp" + stepId]: e.target.value,
        ["offset" + stepId]: this.convertTempToOffset(e.target.value)
      })
    }
  }

  onBlur = (stepId) => {
    let step = this.props.sequence[this.props.props.id - 1];

    step.subSteps.forEach((subStep, index)=>{

      let temp = this.convertOffsetToTemp(this.state["offset"+(index+1)]);
      let duration = this.state["duration"+(index+1)];
      step.subSteps[index].temp = temp;
      step.subSteps[index].duration = duration;

    })

    step.repeat = this.state.repeat;
    this.props.updateSequence({
      id: this.props.id,
      index: this.props.props.id - 1,
      item: step
    });
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.setMaxHeight()
    window.addEventListener("resize", this.setMaxHeight);

    this.setState({
      offset1: this.convertTempToOffset(this.props.props.subSteps[0].temp),
      offset2: this.convertTempToOffset(this.props.props.subSteps[1].temp),
      offset3: this.convertTempToOffset(this.props.props.subSteps[2].temp)
    })
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setMaxHeight);
  }
  componentDidUpdate(prevProps, prevState){
    if(this.saved !== prevProps.saved && !this.props.saved){
      this.save()
      this.props.setSaved({
        id: this.props.id,
        saved: true
      })
    }

    if(
      (
        this.state.temp1 !== prevState.temp1 ||
        this.state.temp2 !== prevState.temp2 ||
        this.state.temp3 !== prevState.temp3 ||
        this.state.duration1 !== prevState.duration1 ||
        this.state.duration2 !== prevState.duration2 ||
        this.state.duration3 !== prevState.duration3 ||
        this.state.repeat !== prevState.repeat
      )// && !this.props.saved
    ){
      this.save()
      this.props.setSaved({
        id: this.props.id,
        saved: true
      })
    }
    if(
      prevState.offset1 !== this.state.offset1 ||
      prevState.offset2 !== this.state.offset2 ||
      prevState.offset3 !== this.state.offset3
     ){
      this.dragToggle1.current.style.transform = "translate3d(0px, "+(this.state.maxHeight - this.state.offset1)+"px, 0px) rotateZ(0deg)"
      this.dragToggle2.current.style.transform = "translate3d(0px, "+(this.state.maxHeight - this.state.offset2)+"px, 0px) rotateZ(0deg)"
      this.dragToggle3.current.style.transform = "translate3d(0px, "+(this.state.maxHeight - this.state.offset3)+"px, 0px) rotateZ(0deg)"
    }
  }

  render() {
    return (
      <div className="cycling-step" style={{display: "flex", flexDirection: "column"}}>
        <div className="step-header">
          <div className="step-blank">
            <span>{this.props.props.id}</span>
            <div>
              <span>Repeat: </span><input value={this.state.repeat} onChange={this.setCycleCount} />
            </div>
          </div>
          <div className="step-sublabels">
            <div className="step-label">
              (A) Denaturation
            </div>
            <div className="step-label">
              (B) Annealing
            </div>
            <div className="step-label">
              (C) Elongation
            </div>
          </div>
        </div>
        <div className="step-substeps">
          {this.props.props.subSteps.map(step => (
            <div>
              <div
                className="step-drag-area"
                onDragStart={this.onDragStart}
                onDragOver={(e)=>{
                  e.persist();
                  this.onDragOver(e, this.props.props.id - 1, step.id - 1);
                }}
                ref={this.dragarea}
                onDragEnd={(e)=>this.onDrop(e, this.props.props.id - 1, step.id - 1)}
                >
                <div
                  className="drag-item"
                  draggable
                  ref={this["dragToggle" + step.id]}
                  style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}
                >
                  <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                  }}>
                    <div style={{
                      display: "flex",
                      flexDirection: "column"
                    }}>
                      <button
                        onClick={()=>this.moveUp(step.id)}
                        style={{
                          background: "none",
                          border: "none",
                          width: "10px",
                          height: "10px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer"
                        }}>
                          <img style={{
                            width: "100%",
                            height: "100%",
                            pointerEvents: "none"
                          }} src={UpIcon} alt="" />
                        </button>
                      <button
                        style={{
                          background: "none",
                          border: "none",
                          width: "10px",
                          height: "10px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}>
                          <img style={{
                            width: "6px",
                            height: "100%",
                            pointerEvents: "none"
                          }} src={DotIcon} alt="" />
                      </button>
                      <button
                        onClick={()=>this.moveDown(step.id)}
                        style={{
                          background: "none",
                          border: "none",
                          width: "10px",
                          height: "10px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer"
                        }}>
                          <img style={{
                            width: "100%",
                            height: "100%",
                            pointerEvents: "none"
                          }} src={DownIcon} alt="" />
                      </button>
                    </div>
                    <input
                      onChange={(e)=>this.onChange(e, step.id)}
                      onBlur={()=>this.onBlur(step.id)}
                      style={{width: "86px", height: "24px", marginRight: "3px"}}
                      value={this.state["temp" + step.id]}
                    />
                    <label style={{pointerEvents: "none"}}>°C</label>
                  </div>
                </div>
              </div>
              <div className="step-footer">
                <TimeInput
                  value={this.state["duration" + step.id]}
                  minValue={0}
                  maxValue={362439}
                  buttonIncrement={1}
                  onChange={(duration) => this.setSubStepDuration(duration, this.props.props.id - 1, step.id - 1)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}
